/** The post-login entry screen for members with multiple active organizations (HS2-658H03). */
import { Button } from '@kerfjs/ui/button';
import { ContentItem } from '@kerfjs/ui/content-item';
import { List } from '@kerfjs/ui/list';
import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { StateBanner } from '@kerfjs/ui/state-banner';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import { CardHeader } from '../../../components/card-header.js';
import { notice, orgs } from '../../../data/state.js';

export function OrganizationChoice(): SafeHtml {
  return (
    <main class="app-entry">
      <div class="entry-card">
        <ContentItem appearance="surface" frame="framed">
          <CardHeader title="Choose an organization" size="xlarge" headingLevel={1} />
          <List gap="m">
            <ListInsetControl>
              <Text tone="quiet">Which organization would you like to work with?</Text>
            </ListInsetControl>
            {notice.value === '' ? null : <StateBanner tone="danger" title={notice.value} />}
            {orgs.value
              .filter((org) => org.status === 'active')
              .map((org) => (
                <ListInsetControl>
                  <Button
                    size="default"
                    tone="brand"
                    emphasis="primary"
                    action="choose-org"
                    rootAttributes={{ 'data-org-id': org.id }}
                  >
                    {org.name}
                  </Button>
                </ListInsetControl>
              ))}
            <ListInsetControl>
              <Button size="default" tone="neutral" emphasis="plain" action="retry-org-choice">
                Refresh organizations
              </Button>
              <Button size="default" tone="neutral" emphasis="plain" action="signout">
                Sign Out
              </Button>
            </ListInsetControl>
          </List>
        </ContentItem>
      </div>
    </main>
  );
}
